import moment from 'moment';
import {
  atom,
} from 'recoil';

export const clientAtom = atom({
  key: 'client',
  default: {},
});


export const loadingAtom = atom({
  key: 'loading',
  default: false
});


export const popupTransactionHistoryAtom = atom({
  key: 'popupTransactionHistory',
  default: {
    updatedAt: moment().valueOf(),
    show: false,
    data: {
      id: '',
      type: '',
    }
  }
});


export const popupCustomerFlowAtom = atom({
  key: 'popupCustomerFlow',
  default: {
    show: false,
    updatedAt: moment().valueOf(),
    data: {
      id: '',
      type: '',
    }
  }
});

export const popupExchangeBetweenBankAccountAtom = atom({
  key: 'popupExchangeBetweenBankAccount',
  default: {
    show: false,
    loading: false,
    updatedAt: moment().valueOf(),
    data: {
      id: '',
    }
  }
});

export const popupPNCustomerFlowAtom = atom({
  key: 'pnPopupCustomerFlow',
  default: {
    show: false,
    updatedAt: moment().valueOf(),
    data: {
      id: '',
      type: '',
    }
  }
});


export const popupPNTransactionHistoryAtom = atom({
  key: 'popupPNTransactionHistory',
  default: {
    updatedAt: moment().valueOf(),
    show: false,
    data: {
      id: '',
      type: '',
    }
  }
});


